import { Directive, Input, ContentChildren, ElementRef } from '@angular/core';
import { NgxCardNumberTemplate, NgxCardNameTemplate, NgxCardExpiryTemplate, NgxCardCvcTemplate } from './inputs';
import * as ɵngcc0 from '@angular/core';
var defaultPlaceholders = {
    number: '•••• •••• •••• ••••',
    name: 'Full Name',
    expiry: '••/••',
    cvc: '•••',
};
var defaultMessages = {
    validDate: 'valid\nthru',
    monthYear: 'month/year',
};
var NgxCard = (function () {
    function NgxCard(element) {
        this.element = element;
        this.formatting = true; // optional - default true
        // if true, will log helpful messages for setting up Card
        this.debug = false; // optional - default false
    }
    Object.defineProperty(NgxCard.prototype, "messages", {
        get: function () {
            return this._messages;
        },
        set: function (_messages) {
            this._messages = Object.assign({}, defaultMessages, _messages);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxCard.prototype, "placeholders", {
        get: function () {
            return this._placeholders;
        },
        set: function (_placeholders) {
            this._placeholders = Object.assign({}, defaultPlaceholders, _placeholders);
        },
        enumerable: true,
        configurable: true
    });
    NgxCard.prototype.ngAfterViewInit = function () {
        new Card({
            form: this.element.nativeElement,
            container: this.container,
            width: this.width,
            formSelectors: {
                numberInput: this.findSelectors(this.numbers),
                expiryInput: this.findSelectors(this.expiries),
                cvcInput: this.findSelectors(this.cvcs),
                nameInput: this.findSelectors(this.names),
            },
            formatting: this.formatting,
            messages: this.messages,
            placeholders: this.placeholders,
            masks: this.masks,
            debug: this.debug,
        });
    };
    NgxCard.prototype.findSelectors = function (list) {
        return list.map(function (template) { return template.elementRef.nativeElement.tagName.toLowerCase() + '[name="' + template.name + '"]'; })
            .join(', ');
    };
NgxCard.ɵfac = function NgxCard_Factory(t) { return new (t || NgxCard)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxCard.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCard, selectors: [["", "card", ""]], contentQueries: function NgxCard_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCardNumberTemplate, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCardNameTemplate, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCardExpiryTemplate, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxCardCvcTemplate, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.numbers = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.names = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expiries = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cvcs = _t);
    } }, inputs: { formatting: "formatting", debug: "debug", messages: "messages", placeholders: "placeholders", container: "container", width: ["card-width", "width"], masks: "masks" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCard, [{
        type: Directive,
        args: [{
                selector: '[card]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { formatting: [{
            type: Input
        }], debug: [{
            type: Input
        }], messages: [{
            type: Input
        }], placeholders: [{
            type: Input
        }], container: [{
            type: Input
        }], width: [{
            type: Input,
            args: ['card-width']
        }], masks: [{
            type: Input
        }], numbers: [{
            type: ContentChildren,
            args: [NgxCardNumberTemplate, { descendants: true }]
        }], names: [{
            type: ContentChildren,
            args: [NgxCardNameTemplate, { descendants: true }]
        }], expiries: [{
            type: ContentChildren,
            args: [NgxCardExpiryTemplate, { descendants: true }]
        }], cvcs: [{
            type: ContentChildren,
            args: [NgxCardCvcTemplate, { descendants: true }]
        }] }); })();
    return NgxCard;
}());
export { NgxCard };
/** @nocollapse */
NgxCard.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
NgxCard.propDecorators = {
    'container': [{ type: Input },],
    'width': [{ type: Input, args: ['card-width',] },],
    'messages': [{ type: Input },],
    'placeholders': [{ type: Input },],
    'masks': [{ type: Input },],
    'formatting': [{ type: Input },],
    'debug': [{ type: Input },],
    'numbers': [{ type: ContentChildren, args: [NgxCardNumberTemplate, { descendants: true },] },],
    'names': [{ type: ContentChildren, args: [NgxCardNameTemplate, { descendants: true },] },],
    'expiries': [{ type: ContentChildren, args: [NgxCardExpiryTemplate, { descendants: true },] },],
    'cvcs': [{ type: ContentChildren, args: [NgxCardCvcTemplate, { descendants: true },] },],
};
;

